import { useAuth } from "../../Hooks/useAuth";

export default function LogoutScreen() {
    const { logout } = useAuth();

    logout();

    return <></>;
}
